import * as yup from "yup";

export const settingsSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Required")
    .min(2, "Min 2 chars")
    .max(255, "Max 255 chars"),
  phoneNumber: yup
    .string()
    .trim()
    .required("Required")
    .min(2, "Min 2 chars")
    .max(255, "Max 255 chars"),
  password: yup.string().trim().max(255, "Max 255 chars").required("Required"),
  description: yup.string().trim().max(1000, "Max 1000 chars"),
});

export type settingsSchemaType = yup.InferType<typeof settingsSchema>;
